"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Backpack_exports = {};
__export(Backpack_exports, {
  default: () => Backpack_default
});
module.exports = __toCommonJS(Backpack_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.63672 10.25C4.86849 10.25 4.21094 9.98307 3.66406 9.44922C3.13021 8.90234 2.86328 8.24479 2.86328 7.47656V4.70312H7.72656V4C7.72656 3.42708 7.92839 2.9388 8.33203 2.53516C8.73568 2.11849 9.22396 1.91016 9.79688 1.91016H11.2031C11.776 1.91016 12.2643 2.11849 12.668 2.53516C13.0716 2.9388 13.2734 3.42708 13.2734 4V4.70312H18.1367V7.47656C18.1367 8.24479 17.8633 8.90234 17.3164 9.44922C16.7826 9.98307 16.1315 10.25 15.3633 10.25H14.6602V9.54688C14.6602 9.36458 14.5951 9.20833 14.4648 9.07812C14.3346 8.9349 14.1719 8.86328 13.9766 8.86328C13.7812 8.86328 13.612 8.9349 13.4688 9.07812C13.3385 9.20833 13.2734 9.36458 13.2734 9.54688V10.25H7.72656V9.54688C7.72656 9.36458 7.65495 9.20833 7.51172 9.07812C7.38151 8.9349 7.21875 8.86328 7.02344 8.86328C6.82812 8.86328 6.66536 8.9349 6.53516 9.07812C6.40495 9.20833 6.33984 9.36458 6.33984 9.54688V10.25H5.63672ZM9.11328 4V4.70312H11.8867V4C11.8867 3.80469 11.8151 3.64193 11.6719 3.51172C11.5417 3.36849 11.3854 3.29688 11.2031 3.29688H9.79688C9.61458 3.29688 9.45182 3.36849 9.30859 3.51172C9.17839 3.64193 9.11328 3.80469 9.11328 4ZM17.6289 10.9531C17.9805 10.9922 18.2669 11.1484 18.4883 11.4219C18.7227 11.6823 18.8398 11.9883 18.8398 12.3398V14.4102C18.8398 14.8008 18.7031 15.1328 18.4297 15.4062C18.1562 15.6667 17.8307 15.7969 17.4531 15.7969C17.4531 16.5651 17.1797 17.2227 16.6328 17.7695C16.0859 18.3164 15.4284 18.5898 14.6602 18.5898H6.33984C5.57161 18.5898 4.91406 18.3164 4.36719 17.7695C3.82031 17.2227 3.54688 16.5651 3.54688 15.7969C3.16927 15.7969 2.84375 15.6667 2.57031 15.4062C2.29688 15.1328 2.16016 14.8008 2.16016 14.4102V12.3398C2.16016 11.9883 2.27083 11.6823 2.49219 11.4219C2.72656 11.1484 3.01953 10.9922 3.37109 10.9531C3.70964 11.1745 4.06771 11.3438 4.44531 11.4609C4.83594 11.5781 5.23307 11.6367 5.63672 11.6367H6.33984V12.3398C6.33984 12.5221 6.40495 12.6849 6.53516 12.8281C6.66536 12.9583 6.82812 13.0234 7.02344 13.0234C7.21875 13.0234 7.38151 12.9583 7.51172 12.8281C7.65495 12.6849 7.72656 12.5221 7.72656 12.3398V11.6367H13.2734V12.3398C13.2734 12.5221 13.3385 12.6849 13.4688 12.8281C13.612 12.9583 13.7812 13.0234 13.9766 13.0234C14.1719 13.0234 14.3346 12.9583 14.4648 12.8281C14.5951 12.6849 14.6602 12.5221 14.6602 12.3398V11.6367H15.3633C15.7669 11.6367 16.1576 11.5781 16.5352 11.4609C16.9258 11.3438 17.2904 11.1745 17.6289 10.9531ZM12.5898 15.7969C12.7721 15.7969 12.9284 15.7318 13.0586 15.6016C13.2018 15.4714 13.2734 15.3086 13.2734 15.1133C13.2734 14.918 13.2018 14.7552 13.0586 14.625C12.9284 14.4818 12.7721 14.4102 12.5898 14.4102H8.41016C8.22786 14.4102 8.0651 14.4818 7.92188 14.625C7.79167 14.7552 7.72656 14.918 7.72656 15.1133C7.72656 15.3086 7.79167 15.4714 7.92188 15.6016C8.0651 15.7318 8.22786 15.7969 8.41016 15.7969H12.5898Z",
      fill: "currentColor"
    }
  )
);
const SvgBackpack = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Backpack_default = SvgBackpack;
